import React, { Component } from 'react';
import config from '../../../config';
import {browserHistory} from 'react-router';
import HeaderLogo from './HeaderLogo';
import HeaderSearch from './HeaderSearch';

let $ = window.jQuery;
let Layout = window.Layout;

export default class MainHeader extends Component {

    handlerDoLogout = () => {
        sessionStorage.clear();
        localStorage.clear();

        location.href = '/';
    };

    handleHeader = () => {
        let $pageHeader = $('.page-header');

        // handle search box expand/collapse
        $pageHeader.on('click', '.search-form', function(e) {
            $(this).addClass("open");
            $(this).find('.form-control').focus();

            $('.page-header .search-form .form-control.tt-input').on('blur', function(e) {
                $(this).closest('.search-form').removeClass("open");
                $(this).unbind("blur");
            });
        });

        // handle hor menu search form on enter press
        $pageHeader.on('keypress', '.hor-menu .search-form .form-control', function(e) {
            if (e.which === 13) {
                $(this).closest('.search-form').submit();
                return false;
            }
        });

        // handle header search button click
        $pageHeader.on('mousedown', '.search-form.open .submit', function(e) {
            e.preventDefault();
            e.stopPropagation();
            $(this).closest('.search-form').submit();
        });
    };

    handleError = (e) => {
        e.target.src = '/images/logo.png';
    };

    handlerGoToMyProfile() {
        browserHistory.push('/user');
    }

    componentDidMount() {
        Layout.init();
        this.handleHeader();

        // Menu Toggler on Change Routes
        let $body = document.querySelector('body');
        let $toggle = document.querySelector('.menu-toggler');

        this.context.router.listen(() => {
            if (! $body.classList.contains('page-sidebar-closed')) {
                $toggle.click();
            }
        });
    }

    render() {
        const { user } = this.props;
        let userInfo;
        let name = '';
        let imageUrl;
        let logoUrl;

        if (user !== null) {
            userInfo = user.get('user_info').toJS();

            if (userInfo.role === 'practitioner' || userInfo.role === 'dentist') {
                name += 'Dr. ';
            }

            name += `${userInfo.firstname} ${userInfo.lastname}`;

            imageUrl = `${config.staticFiles}${userInfo.media_id}`;

            // eslint-disable-next-line
            if (! userInfo.media_id || userInfo.media_id == 0 || userInfo.media_id == null) {
                imageUrl = '/images/generic_profile_pic.png';
            }

            logoUrl = `${config.staticFiles}${sessionStorage.getItem('small_logo')}`;
            if (! sessionStorage.getItem('small_logo')) {
                logoUrl = '/images/logo.png';
            }


            return (
                <div className="page-header navbar navbar-fixed-top">
                    <div className="page-header-inner ">
                        <HeaderLogo />

                        <a href="#" className="menu-toggler responsive-toggler" data-toggle="collapse" data-target=".navbar-collapse"> </a>

                        <div className="page-top">

                            <HeaderSearch history={this.props.history} />

                            <div className="logo">
                                <a href="/home">
                                    <img src={logoUrl}
                                         onError={this.handleError}
                                         style={{ height: '60px', marginTop: '7px' }}
                                         alt="logo" className="logo-default" />
                                </a>
                            </div>

                            <div className="top-menu">
                                <ul className="nav navbar-nav pull-right">
                                    <li className="dropdown dropdown-user">
                                        <a href="#" className="dropdown-toggle" data-toggle="dropdown"
                                           data-hover="dropdown" data-close-others="true">
                                            <div className="img-circle tenantProfilePic" style={{backgroundImage : 'url('+ (imageUrl) +')',backgroundRepeat: 'no-repeat',backgroundSize: 'cover',backgroundPosition: '50% 50%',float: 'left',margin: '-7px 5px',height: '40px',width: '40px',border: '2px solid #ECEFF2',borderRadius: '50%'}}></div>
                                            <span className="username username-hide-on-mobile" id="headerProfileName"> {name} </span>
                                            <i className="fa fa-angle-down"/>
                                        </a>
                                        <ul className="dropdown-menu dropdown-menu-default">
                                            <li>
                                                <a href="#" onClick={this.handlerGoToMyProfile}>
                                                    <i className="icon-user"></i> My Profile
                                                </a>
                                            </li>
                                            <li className="divider"> </li>
                                            <li>
                                                <a href="page_user_lock_1.html">
                                                    <i className="icon-lock"/> Lock Screen </a>
                                            </li>
                                            <li>
                                                <a href="#" onClick={this.handlerDoLogout}>
                                                    <i className="icon-key"/> Log Out </a>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }

        return (
            <div className="page-header navbar navbar-fixed-top"></div>
        )
    }
}

MainHeader.contextTypes = {
    router: React.PropTypes.object.isRequired
};


/** WEBPACK FOOTER **
 ** ./src/commons/Header/MainHeader.js
 **/